import { MESSAGE_TYPE } from 'constants/message'
import isKeyInvalidValidationReduxUtil
from 'modules/redux/utils/is-key-invalid-validation'

/**
 * Gets the message type of a given validation.
 * @param  {Validation} validation
 * @param  {string} key
 * @returns {string}
 */
function getInputValidationMessageTypeComponentUtil (validation, key) {
  if (!isKeyInvalidValidationReduxUtil(validation, key)) {
    return
  }
  return MESSAGE_TYPE.ERROR
}

export default getInputValidationMessageTypeComponentUtil
